import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Calendar,
  MapPin,
  Microscope,
  Users,
  BookOpen,
  GraduationCap,
  ChevronRight,
  Info,
  Award,
  CheckCircle2,
  FileText,
  Clock,
  Globe,
  Gavel,
  TreePine,
  UserCheck,
  Menu,
  X,
  User,
  
  Presentation,
  Shapes,
  ArrowRight,
  CheckCircle,
} from "lucide-react";
import ramiro from "../img/investiga/ramiro.png";
import patricia from "../img/investiga/patricia.jpeg";
import xavier from "../img/investiga/xavier.jpg";
import julio from "../img/investiga/julio.jpeg";
import agenda from "../docs/agenda.pdf";

const Informacion = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [activeRole, setActiveRole] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll handler for navbar effects
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const simposios = [
    {
      title: "Ciencias Políticas, Democracia y Políticas Públicas",
      icon: <Globe className="w-8 h-8" />,
      desc: "Profundiza en procesos políticos y dinámicas democráticas para la construcción de sistemas inclusivos y resilientes.",
      content: (
        <>
          {" "}
          <p className="text-slate-600 text-sm">
            Esta línea temática convoca aportes que exploren la interacción de
            procesos políticos, las dinámicas democráticas y las políticas
            públicas en contextos nacionales e internacionales, así como las
            tensiones derivadas de la gobernanza, la participación ciudadana y
            las desigualdades en el ejercicio del poder. Se valoran propuestas
            que planteen modelos de fortalecimiento institucional más inclusivos
            y resilientes, respetuosos de los derechos humanos y la pluralidad
            política. También se incluyen estudios sobre democracia
            participativa, políticas públicas efectivas y prácticas innovadoras
            que integren análisis comparado, evaluación de impacto y desarrollo
            sostenible.
          </p>
        </>
      ),
    },
    {
      title: "Gobernanza, Territorio y Ciencias de la Vida",
      icon: <TreePine className="w-8 h-8" />,
      desc: "Explora la intersección entre gobernanza territorial, dinámicas socioambientales y ciencias de la vida frente al cambio climático.",
      content: (
        <>
          <p className="text-slate-600 text-sm">
            En este espacio se integran investigaciones que analicen la
            intersección entre gobernanza territorial, dinámicas
            socioambientales y las ciencias de la vida, así como las tensiones
            derivadas de la gestión de recursos naturales, la conservación de la
            biodiversidad y los impactos del cambio climático en los
            ecosistemas. Se valoran propuestas que planteen modelos de
            gobernanza territorial más integrales y sostenibles, respetuosos de
            los ciclos vitales de la naturaleza, la salud humana y los
            conocimientos ancestrales de las comunidades. También se incluyen
            estudios sobre políticas territoriales participativas, ciencias de
            la vida aplicadas a la salud, resiliencia ecológica y prácticas
            innovadoras que integren biotecnología, restauración ambiental y
            desarrollo armónico entre sociedad y naturaleza
          </p>
        </>
      ),
    },
    {
      title: "Derecho, Ciencia y Tecnologías Emergentes",
      icon: <Gavel className="w-8 h-8" />,
      desc: "Analiza la relación entre el derecho, la ciencia y las tecnologías emergentes, comprendiendo los desafíos en la regulación de innovaciones.",
      content: (
        <>
          <p className="text-slate-600 text-sm">
            Investigaciones que analicen la articulación entre el derecho, la
            ciencia y las tecnologías emergentes, así como las tensiones
            derivadas de la regulación de innovaciones como la inteligencia
            artificial, el blockchain y la biotecnología en contextos jurídicos
            nacionales e internacionales. Se valoran propuestas que planteen
            marcos normativos más adaptativos y éticos, respetuosos de los
            derechos fundamentales, la privacidad de datos y la responsabilidad
            algorítmica. También se incluyen estudios sobre gobernanza
            tecnológica participativa, políticas jurídicas innovadoras y
            prácticas que integren evaluación de riesgos legales, protección
            intelectual y desarrollo responsable de la ciencia aplicada.
          </p>
        </>
      ),
    },

    {
      title: "Ciencias Sociales y del Comportamiento",
      icon: <UserCheck className="w-8 h-8" />,
      desc: "Examina los procesos sociales y dinámicas del comportamiento humano en contextos contemporáneos y Derechos Humanos.",
      content: (
        <>
          {" "}
          <p className="text-slate-600 text-sm">
            Esta mesa convoca investigaciones que analicen los procesos
            sociales, las dinámicas del comportamiento humano y las
            interacciones colectivas en contextos contemporáneos, así como las
            tensiones derivadas de desigualdades culturales, cambios en las
            normas sociales y patrones de conducta influenciados por la
            globalización y la digitalización. Se valoran propuestas que
            planteen modelos de análisis social más integrales y empáticos,
            respetuosos de la diversidad cultural, la psicología colectiva y los
            derechos humanos en entornos plurales. También se incluyen estudios
            sobre gobernanza social participativa, políticas públicas basadas en
            evidencia conductual y prácticas innovadoras que integren
            neurociencia social, educación, diseño de intervenciones
            comportamentales y desarrollo.
          </p>
        </>
      ),
    },
  ];

  const ponentes = [
    {
      name: "Julio César Mateus",
      type: "Internacional",
      role: "Doctor en Comunicación (Cum Laude)",
      institution: "Universidad de Lima",
      expo: "Hábitat informacional y resiliencia social: aprendizajes desde la investigación empírica en la comunidad andina",
      bio: "Especialista en culturas digitales y educación con amplia producción académica internacional.",
      img: julio,
    },
    {
      name: "Xavier León Vega",
      type: "Nacional",
      role: "Miembro de GRAIN América Latina",
      institution: "Universidad Amawtay Wasi",
      bio: "Experto en soberanía alimentaria, extractivismo y desarrollo rural.",
      img: xavier,
      expo: "El territorio desde la visión campesina e indígena",
    },
    {
      name: "Ramiro Ávila Santamaría",
      type: "Nacional",
      role: "Doctor en Sociología Jurídica",
      institution: "Universidad Andina Simón Bolívar",
      bio: "Magíster por Columbia Law School y Human Rights Fellow.",
      img: ramiro,
      expo: "La simbiosis del derecho y la ciencia para entender y aplicar los derechos de la naturaleza en tiempos de cambio climático",
    },
    {
      name: "Patricia Sotomayor",
      type: "Nacional",
      role: "Doctora en Ciencia Política",
      institution: "USFQ / AECIP",
      bio: "Presidenta de la Asociación Ecuatoriana de Ciencia Política.",
      img: patricia,
      expo: "Justicia y poder: el rol de los tribunales en la expansión o limitación de la democracia",
    },
  ];

  const estadisticas = [
    { value: "720", label: "Ponencias orales", sub: "Aportes al conocimiento" },
    {
      value: "380",
      label: "Pósteres científicos",
      sub: "Excelencia investigativa",
    },
    { value: "300", label: "Proyectos inst.", sub: "Impacto territorial" },
    { value: "90", label: "Aliados", sub: "Ecosistema de colaboración" },
  ];

  const comite = [
    {
      name: "Gabriela Moreira Aguirre ",
      dept: "Decana de la Facultad de Ciencias Jurídicas y Políticas  ",
      url: "https://investigacion.utpl.edu.ec/dgmoreira ",
    },
    {
      name: "Enrique Luzuriaga Muñoz",
      dept: "Vicedecano de la Facultad de Ciencias Jurídicas y Políticas ",
      url: "https://investigacion.utpl.edu.ec/edluzuriaga",
    },
    {
      name: "Marlon Ramón Mendieta",
      dept: "Docente de la Facultad de Ciencias Económicas y Empresariales",
      url: "https://investigacion.utpl.edu.ec/mgramon ",
    },
    {
      name: "Paúl González Torres",
      dept: "Docente de la Facultad de Ciencias Sociales, Educación y Humanidades ",
      url: "https://investigacion.utpl.edu.ec/pfgonzalez",
    },
    {
      name: "Alexandra Moncayo",
      dept: "Docente de la Facultad de Ingenierías y Arquitectura ",
      url: "https://investigacion.utpl.edu.ec/admoncayo",
    },
    {
      name: "Víctor López Guerra",
      dept: "Docente de la Facultad de Ciencias del Comportamiento ",
      url: "https://investigacion.utpl.edu.ec/vmlopez5",
    },
    {
      name: "María Beatriz Eguiguren",
      dept: "Coordinadora del programa institucional Cultura de Paz, Justicia y Gobernanza para el bien común ",
      url: "https://investigacion.utpl.edu.ec/mbeguiguren",
    },
    {
      name: "Santiago Pérez Samaniego ",
      dept: "Coordinador de Cátedras Unesco UTPL  ",
      url: "https://investigacion.utpl.edu.ec/saperez1 ",
    },
    {
      name: "Juan Andrés Jaramillo ",
      dept: "Director de la Carrera de Derecho ",
      url: "https://investigacion.utpl.edu.ec/jajaramillo ",
    },
    {
      name: "María Gabriela Espinosa",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/mgespinosa ",
    },
    {
      name: "Marcelo Costa Cevallos",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/macosta ",
    },
    {
      name: "Nicole Valarezo",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/nlvalarezo1",
    },

    {
      name: "Luis Ordóñez Pineda",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/loordonez",
    },
    {
      name: "Ana Karina Vera ",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/akvera ",
    },
    {
      name: "Jorge Benítez Hurtado",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/jabenitezxx",
    },
    {
      name: "Pablo Castillo Álvarez ",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/pjcastillo2 ",
    },
    {
      name: "Maleny Reyes Conza",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/mgreyes ",
    },
    {
      name: "Sandra Encarnación Ordoñez",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas",
      url: "https://investigacion.utpl.edu.ec/sjencarnacion ",
    },

    ,
    {
      name: "Carlos García Torres",
      dept: "Docente de la Facultad de Ciencias Jurídicas y Políticas ",
      url: "https://investigacion.utpl.edu.ec/cegarcia ",
    },
  ];

  const requisitos = {
    oral: (
      <>
        <p className="font-bold mb-2">Requisitos:</p>
        <ul className="list-disc pl-5 space-y-1 mb-4">
          <li>
            La investigación debe ser original y no haber sido presentada
            previamente en Investiga.
          </li>
          <li>
            Al menos uno de los autores deberá estar inscrito en el evento.
          </li>
        </ul>

        <p className="font-bold mb-2">Características del resumen:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Extensión de 300 palabras</li>
          <li>Idioma: español o inglés</li>
          <li>Estructura:</li>
        </ul>

        <ul className="pl-8 mt-2 space-y-1 list-[lower-alpha]">
          <li>Título</li>
          <li>Autores e institución</li>
          <li>Palabras clave (3 a 5)</li>
          <li>Introducción</li>
          <li>Objetivo</li>
          <li>Metodología</li>
          <li>Resultados (esperados o preliminares)</li>
        </ul>
        <p className="font-bold mb-2 pt-5"> Formato de presentación:</p>
        <ul className="pl-8 mt-2 space-y-1 list-[lower-alpha]">
          <li>Duración: 10 minutos de exposición + 5 minutos de preguntas.</li>
          <li>Formato: presentación tipo speech en mesas temáticas.</li>
          <li> Idioma: español (se aceptan presentaciones en inglés).</li>
        </ul>
      </>
    ),

    poster: (
      <>
        <p className="font-bold mb-2">Requisitos:</p>
        <ul className="list-disc pl-5 space-y-1 mb-4">
          <li>Participación individual o grupal (máximo 4 autores).</li>
          <li>Contar con un docente tutor (opcional pero recomendado).</li>
          <li>Envío de un resumen.</li>
        </ul>

        <p className="font-bold mb-2">Formato del póster:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Tamaño: A0 vertical</li>
          <li>Contenido sugerido:</li>
        </ul>

        <ul className="pl-8 mt-2 space-y-1 list-[lower-alpha]">
          <li>Título</li>
          <li>Autores e institución</li>
          <li>Introducción</li>
          <li>Metodología</li>
          <li>Resultados</li>
          <li>Conclusiones</li>
          <li>Referencias (breves)</li>
        </ul>

        <p className="font-bold mb-2 pt-5">Exposición:</p>
        <ul className="pl-8 mt-2 space-y-1 list-[lower-alpha]">
          <li>
            Los autores deberán estar presentes durante la sesión asignada.
          </li>
        </ul>
      </>
    ),

    // puedes añadir luego asistente y poster aquí
  };

  return (
    <div className="min-h-screen bg-white font-sans text-slate-800 overflow-x-hidden">
      {/* Hero Section */}

      {/* Intro Quote */}
      <section className=" overflow-hidden  pt-20  pb-10">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto px-4 text-center"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-black text-blue-600 tracking-[0.3em] uppercase mb-4">
              Acerca del evento
            </h2>
            <p className="text-xl md:text-2xl text-[#002855] leading-relaxed font-medium italic">
              En su décima cuarta edición, impulsa estratégicamente el
              conocimiento frente a los desafíos contemporáneos, posicionándose
              como uno de los principales encuentros de divulgación e innovación
              del país. Articula capacidades académicas, territoriales e
              institucionales para incidir en los desafíos de gobernanza,
              justicia y cohesión social, bajo el eje{" "}
              <b>
                {" "}
                “Gobernanza, Justicia y Cultura de Paz para sociedades
                sostenibles".
              </b>
            </p>
            <div className="mt-10">
              <a
                href={agenda}
                className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white shadow-md transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Descarga la agenda del evento
              </a>
            </div>
          </motion.div>
        </motion.div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mx-auto max-w-5xl overflow-hidden rounded-3xl bg-white shadow-xl"
          >
            <div className="grid lg:grid-cols-2">
              {/* Lado izquierdo */}
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-10 text-white">
                <div className="inline-flex rounded-2xl bg-white/10 p-4 backdrop-blur">
                  <User className="h-10 w-10" />
                </div>

                <h2 className="mt-6 text-4xl font-bold text-white">Registro Asistente</h2>

                <p className="mt-4 text-lg text-blue-100">
                  Vive la experiencia académica completa y forma parte de este
                  encuentro de aprendizaje, reflexión e inspiración.
                </p>

                <div className="mt-8 rounded-2xl bg-white/10 p-5 backdrop-blur">
                  <div className="flex items-center gap-3">
                    <Award className="h-6 w-6" />
                    <span className="font-semibold">
                      Certificado Digital Validado
                    </span>
                  </div>

                  <p className="mt-3 text-sm text-blue-100">
                    Obtén tu certificado oficial participando en al menos
                    <strong> 3 de las 4 sesiones programadas.</strong>
                  </p>
                </div>
              </div>

              {/* Lado derecho */}
              <div className="p-10">
                <h3 className="mb-6 text-2xl font-bold text-slate-900">
                  Tu inscripción incluye
                </h3>

                <div className="space-y-5">
                  <div className="flex items-center gap-4 rounded-2xl border border-slate-200 p-4">
                    <Presentation className="h-6 w-6 text-blue-600" />
                    <div>
                      <h4 className="font-semibold m-0 p-0">
                        Conferencias magistrales
                      </h4>
                      <p className="text-sm text-slate-500 m-0 p-0">
                        Acceso a todas las ponencias principales del evento.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 rounded-2xl border border-slate-200 p-4">
                    <Shapes className="h-6 w-6 text-blue-600" />
                    <div>
                      <h4 className="font-semibold m-0 p-0">
                        Actividades complementarias
                      </h4>
                      <p className="text-sm text-slate-500 m-0 p-0">
                        Espacios de interacción, aprendizaje y networking.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 rounded-2xl border border-green-200 bg-green-50 p-4">
                    <CheckCircle className="h-6 w-6 text-green-600" />
                    <div>
                      <h4 className="font-semibold text-green-800">
                        Certificación digital
                      </h4>
                      <p className="text-sm text-green-700">
                        Participa en 3 de las 4 sesiones y recibe tu
                        certificado.
                      </p>
                    </div>
                  </div>
                </div>

                <a  href="https://matriculas.utpl.edu.ec/landing/event?c=EV00708" className="mt-8 flex items-center gap-2 rounded-xl bg-blue-600 px-6 py-4 font-semibold text-white transition hover:bg-blue-700">
                  Registro Asistente
                  <ArrowRight className="h-4 w-4" />
                </a >
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Simposios */}

      <div
        id="simposios"
        className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl m-auto pb-20"
      >
        {simposios.map((item, idx) => (
          <motion.div
            key={idx}
            variants={fadeInUp}
            whileHover={{ y: -12 }}
            className="group p-5 rounded-[2rem] border border-slate-100 shadow-sm hover:shadow-2xl hover:border-[#FFC72C]/30 transition-all duration-300 flex flex-col"
          >
            <div className="w-20 h-20 bg-blue-50 text-[#002855] rounded-3xl flex items-center justify-center mb-8 group-hover:bg-[#002855] group-hover:text-white transition-all duration-300">
              {item.icon}
            </div>

            <h3 className="text-xl font-bold mb-5 text-[#002855] leading-snug">
              {item.title}
            </h3>

            <p className="text-slate-600 text-sm leading-relaxed mb-6 group-hover:text-slate-900 transition-colors">
              {item.desc}
            </p>

            {/* Botón + abajo */}
            <button
              onClick={() => setSelectedItem(item)}
              className="mt-auto text-[#002855] font-bold text-3xl hover:text-[#FFC72C] transition-colors"
            >
              +
            </button>
          </motion.div>
        ))}
      </div>

      {selectedItem && (
        <div
          onClick={() => setSelectedItem(null)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white max-w-2xl w-full p-8 rounded-2xl relative shadow-xl"
          >
            {/* Botón cerrar */}
            <button
              onClick={() => setSelectedItem(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>

            <h3 className="text-2xl font-bold text-[#002855] mb-4">
              {selectedItem.title}
            </h3>

            <div className="text-slate-700 text-sm leading-relaxed">
              {selectedItem.content}
            </div>
          </div>
        </div>
      )}

      {/* Ponentes Section */}
      <section
        id="ponentes"
        className="py-32 bg-slate-900 text-white relative overflow-hidden"
      >
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern
                id="grid"
                width="40"
                height="40"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 40 0 L 0 0 0 40"
                  fill="none"
                  stroke="white"
                  strokeWidth="1"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>

        <div className="max-w-7xl mx-auto  sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-24">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-5xl font-bold text-white mb-6"
            >
              Ponentes Magistrales
            </motion.h2>
            <p className="text-white max-w-2xl mx-auto text-lg">
              Reuniendo el liderazgo global en investigación para compartir
              visiones que transforman territorios.
            </p>
          </div>

          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
          >
            {ponentes.map((p, idx) => (
              <motion.div
                key={idx}
                variants={fadeInUp}
                whileHover={{ y: -15 }}
                className="group bg-slate-800/50 backdrop-blur-md rounded-3xl overflow-hidden border border-white/5 hover:border-[#FFC72C]/40 transition-all"
              >
                <div className="h-72 overflow-hidden relative">
                  <img
                    src={p.img}
                    alt={p.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700"
                  />
                  <div className="absolute top-6 left-6">
                    <span
                      className={`text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest ${p.type === "Internacional" ? "bg-[#FFC72C] text-[#002855]" : "bg-blue-600 text-white"}`}
                    >
                      {p.type}
                    </span>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-black m-0 p-0 group-hover:text-[#FFC72C] transition-colors">
                    {p.name}
                  </h3>

                  <p className="text-[#FFC72C] text-xs font-black uppercase mb-6 tracking-widest">
                    {p.institution}
                  </p>
                  {p.expo && (
                    <p className="italic text-cyan-300 text-sm leading-none">
                      {" "}
                      {p.expo}
                    </p>
                  )}

                  <p className="text-slate-400 text-sm italic mb-6 leading-relaxed">
                    "{p.role}"
                  </p>
                  <p className="text-slate-300 text-sm leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {p.bio}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Participation Methods */}
      <section id="participar" className="py-32 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-24">
            <h2 className="text-sm font-black text-blue-600 tracking-[0.3em] uppercase mb-6">
              Formas de ser parte
            </h2>
            <p className="text-5xl font-bold text-[#002855]">
              Únete a Investiga XIV 2026
            </p>
          </div>
          <div className="grid lg:grid-cols-3 gap-10 items-stretch">
            {/* Assistant */}
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-[2.5rem] p-12 border border-slate-200 shadow-sm flex flex-col h-full group"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#002855] transition-colors">
                <Users className="w-8 h-8 text-blue-600 group-hover:text-white" />
              </div>

              <h3 className="text-3xl font-black mb-6 text-[#002855]">
                Asistente
              </h3>

              <p className="text-slate-600 text-lg mb-4">
                Vive la experiencia académica completa y obtén tu certificado
                digital validado.
              </p>

              <p className="text-slate-600 text-lg mb-6">
                Para obtener tu certificado deberás participar en al menos 3 de
                las cuatro sesiones.
              </p>

              <ul className="space-y-4 mb-8">
                {[
                  "Conferencias magistrales",
                  "Actividades complementarias",
                ].map((li, i) => (
                  <li
                    key={i}
                    className="flex items-center text-slate-700 font-medium"
                  >
                    <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 shrink-0" />
                    {li}
                  </li>
                ))}
              </ul>

              {/* CTA abajo */}
              <motion.a
                href="https://matriculas.utpl.edu.ec/landing/event?c=EV00708 "
                target="_blank"
                whileTap={{ scale: 0.95 }}
                className="mt-auto w-full py-5 text-center rounded-2xl border-2 border-blue-600 text-blue-600 font-black hover:bg-blue-50 transition"
              >
                Registro Asistente
              </motion.a>
            </motion.div>

            {/* Oral Presentation */}
            <motion.div
              whileHover={{ scale: 1.05, y: -10 }}
              className="bg-[#002855] rounded-[2.5rem] p-12 shadow-2xl flex flex-col text-white relative overflow-hidden h-full"
            >
              <div className="absolute top-0 right-0 p-8">
                <div className="bg-[#FFC72C] text-[#002855] text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest animate-pulse">
                  Convocatoria
                </div>
              </div>

              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-8">
                <BookOpen className="w-8 h-8 text-[#FFC72C]" />
              </div>
              <p className="text-sm font-bold text-[#FFC72C] mb-4 animate-pulse">
                Postula hasta el 10 de mayo
              </p>
              <h3 className="text-3xl font-black m-0 p-0">
                Comunicaciones Orales
              </h3>
              <p className="text-sm text-amber-100 mb-4">
                (docentes e investigadores){" "}
              </p>

              <p className="text-blue-100 text-lg mb-6">
                Posiciona tu trabajo científico en un entorno de alto nivel y
                diálogo crítico.
              </p>

              {/* Botón requisitos */}
              <button
                onClick={() => setActiveRole("oral")}
                className="text-sm font-bold text-white flex items-center gap-2 mb-6 hover:text-[#FFC72C] transition"
              >
                <span className="text-xl leading-none">+</span>
                Conoce los requisitos
              </button>

              <ul className="space-y-4 mb-8">
                {[
                  "Diálogo crítico de saberes",
                  "Networking institucional",
                  "Publicación en Revista Cultura de Paz o Libro con revisión por pares (sujeto a evaluación)",
                ].map((li, i) => (
                  <li
                    key={i}
                    className="flex items-center text-blue-200 font-medium"
                  >
                    <CheckCircle2 className="w-5 h-5 text-[#FFC72C] mr-3 shrink-0" />
                    {li}
                  </li>
                ))}
              </ul>

              {/* CTA abajo */}
              <motion.a
                href="https://sica.utpl.edu.ec/"
                whileTap={{ scale: 0.95 }}
                className="mt-auto w-full py-5 text-center text-white rounded-2xl bg-[#FFC72C] font-black hover:bg-yellow-400 hover:text-[#004270] transition shadow-xl"
              >
                Postular Resumen
              </motion.a>

              <p className="text-xs pt-6">
                Si no estás registrado en la plataforma, deberás crear una
                cuenta de usuario.
              </p>

              <a
                className="text-xs underline"
                href="https://sica.utpl.edu.ec/register"
              >
                Crear un usuario
              </a>
            </motion.div>

            {/* Poster */}
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-[2.5rem] p-12 border border-slate-200 shadow-sm flex flex-col h-full group"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#002855] transition-colors">
                <FileText className="w-8 h-8 text-blue-600 group-hover:text-white" />
              </div>
              <p className="text-sm font-bold text-[#004270] mb-4 animate-pulse">
                Postula hasta el 10 de mayo
              </p>
              <h3 className="text-3xl font-black text-[#002855] m-0 p-0">
                Póster Científico
              </h3>
              <p className="text-sm text-[#004270] mb-4">
                (estudiantes de grado y posgrado){" "}
              </p>

              <p className="text-slate-600 text-lg mb-6">
                Formato dinámico para compartir avances investigativos e
                interactuar con pares.
              </p>
              {/* Botón requisitos */}
              <button
                onClick={() => setActiveRole("poster")}
                className="text-sm font-bold text-amber-500 flex items-center gap-2 mb-6 hover:text-[#FFC72C] transition"
              >
                <span className="text-xl leading-none">+</span>
                Conoce los requisitos
              </button>

              <ul className="space-y-4 mb-8">
                {[
                  "Formato visual interactivo",
                  "Evaluación de comité",
                  "Reconocimiento por mesa",
                ].map((li, i) => (
                  <li
                    key={i}
                    className="flex items-center text-slate-700 font-medium"
                  >
                    <CheckCircle2 className="w-5 h-5 text-green-500 mr-3 shrink-0" />
                    {li}
                  </li>
                ))}
              </ul>

              {/* CTA abajo */}
              <motion.a
                href="https://sica.utpl.edu.ec/"
                whileTap={{ scale: 0.95 }}
                className="mt-auto w-full py-5 rounded-2xl border-2 text-center border-blue-600 text-blue-600 font-black hover:bg-blue-50 transition"
              >
                Postular Póster
              </motion.a>

              <p className="text-xs pt-6 text-slate-600">
                Si no estás registrado en la plataforma, deberás crear una
                cuenta de usuario.
              </p>

              <a
                className="text-xs underline text-slate-600"
                href="https://sica.utpl.edu.ec/register"
              >
                Crear un usuario
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {activeRole && (
        <div
          onClick={() => setActiveRole(null)}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-[#002855]  max-w-xl w-full max-h-[80vh] overflow-y-auto p-8 rounded-2xl relative shadow-2xl"
          >
            <button
              onClick={() => setActiveRole(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button>

            <div className="text-slate-700 text-sm leading-relaxed">
              {requisitos[activeRole]}
            </div>
          </div>
        </div>
      )}

      {/* Scientific Committee */}
      <section className="py-32 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-end mb-20">
            <div>
              <h2 className="text-sm font-black text-blue-600 tracking-widest uppercase mb-4">
                Excelencia Académica
              </h2>
              <p className="text-5xl font-bold text-[#002855]">
                Comité Científico
              </p>
            </div>
          </div>

          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6"
          >
            {comite.map((m, i) => (
              <motion.div
                key={i}
                variants={fadeInUp}
                whileHover={{ scale: 1.02 }}
                className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-lg transition-all group"
              >
                <p className="font-black text-[#002855] group-hover:text-blue-600 transition-colors">
                  {m.name}
                </p>
                <p className="text-xs text-slate-500 mt-2 italic font-medium leading-relaxed">
                  {m.dept}
                </p>
                <div className="mt-4">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={m.url}
                    className="inline-flex items-center gap-1 text-[#004270] text-xs font-semibold uppercase tracking-wider opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:text-[#0066a3]"
                  >
                    Ver perfil
                    <ChevronRight
                      size={14}
                      className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                  </a>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Stats - Infographic */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-24 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              {" "}
              <h2 className="text-sm font-black text-blue-600 tracking-widest uppercase mb-4">
                Ediciones Anteriores
              </h2>
              <h2 className="text-4xl font-black text-[#002855] mb-8 leading-tight">
                Un legado de investigación que trasciende fronteras
              </h2>
              <p className="text-xl text-slate-600 mb-10 leading-relaxed">
                Investiga se consolida como un nodo de conocimiento colectivo,
                promoviendo soluciones sostenibles frente a los grandes desafíos
                del desarrollo.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-2xl bg-green-50 flex items-center justify-center shrink-0">
                    <CheckCircle2 className="text-green-500" />
                  </div>
                  <div>
                    <h5 className="font-black text-[#002855]">
                      Memorias con ISBN
                    </h5>
                    <p className="text-sm text-slate-500">
                      15 volúmenes publicados de alto rigor.
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-2xl bg-blue-50 flex items-center justify-center shrink-0">
                    <CheckCircle2 className="text-blue-500" />
                  </div>
                  <div>
                    <h5 className="font-black text-[#002855]">
                      Instituciones Aliadas
                    </h5>
                    <p className="text-sm text-slate-500">
                      Red de 90+ organizaciones globales.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              className="grid grid-cols-2 gap-8"
            >
              {estadisticas.map((stat, idx) => (
                <motion.div
                  key={idx}
                  variants={fadeInUp}
                  className="bg-[#004270] p-10 rounded-[2.5rem] border-b-8 border-blue-100 flex flex-col justify-center items-center text-center hover:bg-[#002855] hover:text-white hover:border-[#FFC72C] transition-all duration-300"
                >
                  <p className="text-5xl font-black mb-2">{stat.value}</p>
                  <p className="text-sm font-black uppercase tracking-tighter mb-1">
                    {stat.label}
                  </p>
                  <p className="text-xs opacity-60 font-medium">{stat.sub}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>

          <ul className="space-y-3 mt-10">
            <li>
              <a
                href="https://utpl.edu.ec/investiga/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#004270] hover:text-[#0066a3] transition-colors duration-200 font-medium"
              >
                <FileText size={18} />
                Investiga XIII
              </a>
            </li>

            <li>
              <a
                href="https://utpl.edu.ec/investiga/investiga-12"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#004270] hover:text-[#0066a3] transition-colors duration-200 font-medium"
              >
                <FileText size={18} />
                Investiga XII
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Informacion;
